import { render } from "./DeploymentUpdateNotice.vue?vue&type=template&id=33c611b5&scoped=true"
import script from "./DeploymentUpdateNotice.vue?vue&type=script&lang=js"
export * from "./DeploymentUpdateNotice.vue?vue&type=script&lang=js"

import "./DeploymentUpdateNotice.vue?vue&type=style&index=0&id=33c611b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c611b5"]])

export default __exports__